module.exports = {
    aid: {
        firstname: '/name/firstName',
        lastname: '/name/lastName',
        emails: '/[emails]/address',
    },
    application: {
        firstname: '/name/firstName',
        lastname: '/name/lastName',
        emails: '/[emails]/address',
    },
    inquiry: {
        firstname: '/firstName',
        lastname: '/lastName',
        emails: '/[emails]/address',
    },
};
